/* selected-facets-list/index.js */

export default class SelectedFacetsListBtn {
    constructor() {
        this.BLOCK = null;
        this.AJAX_PARAM = null;
    }

    /**
     * Inits instance
     * @param node - DOM node
     */
    init(node) {
        this.BLOCK = node;
        if (!this.BLOCK) throw new Error('node is not passed to init method of instance');

        this.BLOCK.addEventListener('click', this.handleItemClick);
    }

    destroy() {
        this.BLOCK = null;
    }

    /* it would be great to store eventListeners in array to have possibility removeEventListener */
    removeAllListeners() {}

    /**
     * Handles content click
     * @param e {Object} - event object
     */
    handleItemClick = e => {
        // apcLogService('searchResultsPage.filterPill.remove', {
        //     name: this.BLOCK.dataset.itemName,
        //     target: e.target
        // }) //4;
        let target = e.target;
        if (target.closest('.selected-facets__list')) {
            this.AJAX_PARAM = target.dataset.ajaxParam;
            if (this.AJAX_PARAM) {
                this.createAndDispatchEvent();
            } else {
                throw new Error('data-ajax-param is not set');
            }
        }
    };

    /**
     * Creates and dispatches custom event
     */
    createAndDispatchEvent() {
        let event = new CustomEvent('ajax-src-container-click', {
            bubbles: true,
            detail: { ajaxParam: this.AJAX_PARAM },
        });

        this.BLOCK.dispatchEvent(event);
        this.AJAX_PARAM = null;
    }
}

/* \ selected-facets-list/index.js */
